import { baseRestApi } from "api/rest/baseRestApi";
import { ApiResponse } from "api/rest/types/responses";

import { LoadStatusUpdate } from "./types";

type QueryParams = {
  loadId: number;
  stopId: number;
};

type QueryArgs = {
  queryParams: QueryParams;
};

type ResponseType = ApiResponse<LoadStatusUpdate[]>;

module.hot?.accept();

export const getLoadStatusUpdatesBrokerApi = baseRestApi
  .enhanceEndpoints({ addTagTypes: ["LOAD_STATUS_UPDATES"] })
  .injectEndpoints({
    overrideExisting: module.hot?.status() === "apply",
    endpoints: (builder) => ({
      getLoadStatusUpdatesBroker: builder.query<ResponseType, QueryArgs>({
        query: ({ queryParams }) => ({
          method: "GET",
          url: `/broker/load-status-updates`,
          params: {
            truckId: queryParams.loadId,
            stopId: queryParams.stopId,
          },
        }),
      }),
    }),
  });

export const { useGetLoadStatusUpdatesBrokerQuery, useLazyGetLoadStatusUpdatesBrokerQuery } =
  getLoadStatusUpdatesBrokerApi;
